 <div class="p-1" [dir]="this.app.getUserDire()">
    <div class="row">
        <!-- [ngClass]="{'text-alig-end': app?.getUserLanguage() == 'ar'}" -->
        <p class="mb-4 mainP">{{ "Login.youMustBeLog" | translate }}</p>
        <!-- [ngClass]="{'justify-content-end': app?.getUserLanguage() == 'en'}" -->
        <div class="col-12 d-flex justify-content-center">
            <button (click)="onLogInBtnClick()"  class="btn btnBgMainC mx-2">{{ "Login.Login" | translate }}</button>
            <button (click)="onNoClick()" class="btn cancelBtn">{{ "doctorProfile.cancel" | translate }}</button>
        </div>
    </div>
</div>